import React from 'react';
import { HotelOptionDetailDestinationMultiple, QuotationDestinationMultipleSummaryPriceCombination } from '../../types';
import { NewRoomPricesMultiDestinationPreviewCard } from '../RoomPricesMultiDestinationPreviewCard/new';
import { RoomCardsCarousel } from '../CardsCarousel';
import { GetPAXTotalsResponse } from '../../helpers';

interface Props {
	combination: QuotationDestinationMultipleSummaryPriceCombination;
	hotels: HotelOptionDetailDestinationMultiple[];
	paxTotals: GetPAXTotalsResponse;
	showUtility: boolean;
	markup: number | null;
	localCurrency: string;
	exchangeRate: number;
	showLocalCurrency?: boolean;
	isExternal?: boolean;
	primaryInLocalCurrency?: boolean;
	/** Línea de "qué incluye" debajo del total de cada habitación. */
	includedSummary?: string;
}

export const RoomPricesMultiDestinationPreviewList = ({
	combination,
	paxTotals,
	showUtility,
	markup,
	hotels,
	localCurrency,
	exchangeRate,
	showLocalCurrency,
	isExternal,
	primaryInLocalCurrency,
	includedSummary,
}: Props): JSX.Element => {
	const keyStringCombination = combination.keys
		.map((x) => x.destinationIndex + '-' + x.destinationCode + '-' + x.hotelId + '-' + x.hotelProvider + x.boardsKey)
		.join('-');
	// El layout (1-2 visibles / 3+ carrusel con flechas) lo decide
	// RoomCardsCarousel — mismo criterio que el drawer de destino simple.
	return (
		<RoomCardsCarousel>
			{combination.roomsSummaryPrice.map((roomSummaryPrice, indexRoom) => (
				<NewRoomPricesMultiDestinationPreviewCard
					key={keyStringCombination + '-' + indexRoom}
					localCurrency={localCurrency}
					exchangeRate={exchangeRate}
					showLocalCurrency={showLocalCurrency}
					primaryInLocalCurrency={primaryInLocalCurrency}
					roomsSummaryPrice={roomSummaryPrice}
					hotels={hotels}
					paxTotals={paxTotals}
					indexRoom={indexRoom}
					showUtility={showUtility}
					markup={markup}
					oneRoomOnQuotation
					includedSummary={includedSummary}
					isExternal={isExternal}
				/>
			))}
		</RoomCardsCarousel>
	);
};
